import z from "zod/v4";

export const deleteSmsTemplate = {
  name: "deleteSmsTemplate" as const,
  input: z.object({ id: z.string() }),
  output: z.boolean(),
};
